module.exports = "/_next/static/images/big-trash-7899fffa665b51e34d42ba7617583dcb.png";